import React from 'react'
import * as $ from 'jquery';
import { orderPaymentsLoad, orderPaymentEdit } from '../../../../redux/actions/order/orderPaymentActions';
import { useDispatch } from 'react-redux';

export default function RefundsButton(props) {
  const { children, orderId } = props
  const dispatch = useDispatch()

  const handlePaymentEdit = (data) => {
    dispatch(orderPaymentEdit('New'))
    dispatch(orderPaymentsLoad(orderId, { filter: { payment_type: 'refund' }, include: ['staff'] }))
    $("#orderRefundForm-modal").modal()
    $('#Refund-tab').tab('show')
  }

  return (
    <span className="pointer" onClick={handlePaymentEdit}>
      {children}
    </span>
  )
}
